<template>
    <card>
      <template slot="header">
        <h3 class="card-title">Undertime Approval</h3>
      </template>
      <nav class="row">
        <ol class="breadcrumb arr-right bg-breadcrum">
          <li class="breadcrumb-item">
            <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/hr/undertimerequest">Undertime Request</router-link>
          </li>
          <li class="breadcrumb-item active">Undertime Approval</li>
        </ol>
      </nav>
      <hr style="margin-top:-10px"/>
      <form @submit.prevent="update_form">
        <div class="row">
          <div class="col-md-12">
            <b-alert show dismissible v-if="item.hr_status == 'pending'">
              <strong>{{ item.full_name | capitalize}}</strong> - Request for a Undertime approval.
            </b-alert>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Date Filled:</label>
              <input type="date" v-model="item.date_filled" class="form-control" disabled>
            </div>
            <div class="form-group">
              <label>Date of Undertime:</label>
              <input type="date" v-model="item.date_of_undertime" class="form-control" disabled>
            </div>
            <div class="form-group">
              <label>Total Hours:</label>
              <input type="text" v-model="item.total_hours" class="form-control" disabled>
            </div>
            <div class="form-group">
              <label>HR Department Approval: </label>
              <select class="form-control" v-model="item.hr_status" @change="reasonRejected">
                <option disabled value="">-- Please select one --</option>
                <option value="approved">Approve Request</option>
                <option value="rejected">Decline Request</option>
                <option value="pending">Pending Request</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Purpose</label>
              <textarea rows="11"class="form-control" v-model="item.purpose" disabled></textarea>
            </div>
          </div>
        </div>
        <div v-if="reason==true">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <p><b>Reason:</b></p>
                <small><i>Please write a reason why you decline his/her leave request.</i></small>
                <textarea  v-model="reason_to_declined" rows="5" class="form-control reason"></textarea>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="form-group">
          <div class="float-right">  
            <br/> <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Subtmit Request</button> <br/><br/>
          </div>
        </div>
        <br/> <br/>   
      </form>
    </card>
  </template>
    <script>
    /* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card
  },
  data() {
    return {
      item: {},
      reason: false,
      reason_to_declined: ''
    }
  },
  created: function () {
    this.getItem();
  },
  methods: {
    reasonRejected() {
      if (this.item.hr_status == 'rejected') {
        this.reason = true
      } else {
        this.reason = false
      }
    },

    getItem() {
      axios.get('api/undertimerequest/get/' + this.$route.params.id)
      .then(resp => {
        this.item = resp.data;
        console.log(JSON.stringify(resp.data));
      });
    },
    update_form(e) {
      e.preventDefault();
      axios.post('api/undertime/approval/' + this.item.id, {
          hr_status: this.item.hr_status,
          hr_reason_to_declined: this.reason_to_declined,
          hr_date_approved: new Date()
        })
        .then(response => {
          this.$swal({
            type: 'success',
            title: 'Updated',
            html: 'Undertime request has been <br/> successfully  updated.<br/><br/><br/><br/>',
            showConfirmButton: false,
            timer: 2000
          })

          this.$router.push({
            name: 'undertime-request'
          });
          console.log(response.data)
        })
        .catch(error => {
          console.log(error)
        });
    }

  },
}
    </script>
    
    
    
    


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-edit-undertime-request.vue